export enum PromptExecutionType {
  ChatCompletion = "ChatCompletion",
  Completion = "Completion",
}
